<p-drawer
  [(visible)]="visible"
  [position]="'right'"
  [style]="{ width: '500px' }"
  [modal]="true"
  (onHide)="close()">
  <ng-template pTemplate="header">
    <div class="drawer-header">
      <img src="/voximplant.svg" class="voximplant-icon" alt="Voximplant" />
      <h2>Connect phone number using Voximplant</h2>
    </div>
  </ng-template>

  <div
    class="drawer-content"
    snAssistantSurface="importNumber"
    i18n-surfaceTitle="@@importNumber.surface"
    surfaceTitle="Connect a phone number">
    @if (!showAddAccountForm) {
      <!-- Label -->
      <div class="form-field">
        <label for="vox-label" class="field-label">Label</label>
        <input
          pInputText
          id="vox-label"
          [(ngModel)]="label"
          [snAssistantId]="F.label"
          placeholder="Easy to identify name of the phone number"
          class="w-full">
      </div>
    }

    @if (!showAddAccountForm) {
      <!-- Voximplant Account -->
      <div class="form-field">
        <label for="vox-account" class="field-label">Voximplant Account</label>

        <p-select
          [(ngModel)]="selectedAccountId"
          [snAssistantId]="F.account"
          snAssistantLabel="Voximplant account"
          [options]="accountOptions"
          placeholder="Select an existing account or add a new one"
          [disabled]="isLoadingAccounts"
          [filter]="true"
          [showClear]="true"
          filterPlaceholder="Search accounts..."
          [loading]="isLoadingAccounts"
          (onChange)="onAccountChange()"
          class="w-full"
          styleClass="w-full">
        </p-select>

        <p-button
          label="Add New Account"
          icon="pi pi-plus"
          severity="secondary"
          [outlined]="true"
          size="small"
          class="add-account-btn"
          (click)="showAddAccountFormClick()">
        </p-button>
      </div>
    }

    @if (!showAddAccountForm) {
      <!-- Application -->
      <div class="form-field">
        <label for="vox-application" class="field-label">Application</label>
        <small class="help-text">
          If you don't have an application yet, create one at
          <a href="https://manage.voximplant.com/applications" target="_blank" rel="noopener">Applications</a>
          in your Voximplant control panel.
        </small>

        @if (applicationsLoadError) {
          <div class="error-state">
            <p class="error-message">Failed to load applications</p>
            <p-button
              label="Reload"
              icon="pi pi-refresh"
              size="small"
              (click)="reloadApplications()">
            </p-button>
          </div>
        } @else {
          <p-select
            [(ngModel)]="selectedApplicationId"
            [snAssistantId]="F.application"
            snAssistantLabel="Voximplant application"
            [options]="applicationOptions"
            placeholder="Select an application"
            [filter]="true"
            [showClear]="true"
            filterPlaceholder="Search applications..."
            [loading]="isLoadingApplications"
            [disabled]="isLoadingApplications || !selectedAccountId"
            (onChange)="onApplicationChange()"
            class="w-full"
            styleClass="w-full">
          </p-select>
        }
      </div>
    }

    @if (!showAddAccountForm) {
      <!-- Phone Number -->
      <div class="form-field">
        <label for="vox-phoneNumber" class="field-label">Phone number</label>

        @if (phoneNumbersLoadError) {
          <div class="error-state">
            <p class="error-message">Failed to load phone numbers</p>
            <p-button
              label="Reload"
              icon="pi pi-refresh"
              size="small"
              (click)="reloadPhoneNumbers()">
            </p-button>
          </div>
        } @else {
          <p-select
            [(ngModel)]="selectedPhoneNumber"
            [snAssistantId]="F.phoneNumber"
            snAssistantLabel="Phone number"
            [options]="phoneNumberOptions"
            placeholder="Select a phone number"
            [filter]="true"
            [showClear]="true"
            filterPlaceholder="Search phone numbers..."
            [loading]="isLoadingPhoneNumbers"
            [disabled]="isLoadingPhoneNumbers || selectedApplicationId == null"
            class="w-full"
            styleClass="w-full">
          </p-select>
        }
      </div>
    }

    <!-- Add New Account Card -->
    @if (showAddAccountForm) {
      <p-card class="add-account-card">
        <div class="form-field">
          <label for="vox-keyJson" class="field-label">Service Account Key (JSON)</label>
          <small class="help-text">
            Go to <a href="https://manage.voximplant.com/settings/service_accounts" target="_blank" rel="noopener">Settings → Service accounts</a>
            in Voximplant control panel, create a service account and download the JSON key. Required roles:
          </small>
          <div class="roles-chips">
            <p-chip label="Developer" />
            <p-chip label="Scenarios access" />
            <p-chip label="Phone number manager" />
            <p-chip label="ACD Statistics view" />
            <p-chip label="User list view" />
            <p-chip label="Call history view" />
          </div>
          <textarea
            pTextarea
            id="vox-keyJson"
            [(ngModel)]="newKeyJson"
            snAssistantSkip
            placeholder="Paste your service account key JSON here"
            rows="6"
            [autoResize]="true"
            class="w-full key-json-textarea">
          </textarea>
        </div>

        <div class="card-actions">
          <p-button
            label="Cancel"
            severity="secondary"
            [outlined]="true"
            size="small"
            (click)="cancelAddAccount()"
            [disabled]="isAddingAccount">
          </p-button>
          <p-button
            [label]="isAddingAccount ? 'Adding...' : 'Add New Account'"
            size="small"
            [icon]="isAddingAccount ? 'pi pi-spin pi-spinner' : ''"
            (click)="addNewAccount()"
            [disabled]="isAddingAccount || !newKeyJson">
          </p-button>
        </div>
      </p-card>
    }
  </div>

  <ng-template pTemplate="footer">
    <div class="drawer-footer">
      <p-button
        label="Cancel"
        severity="secondary"
        [outlined]="true"
        (click)="close()"
        [disabled]="isImporting">
      </p-button>
      <p-button
        [label]="isImporting ? 'Connecting...' : 'Connect'"
        [icon]="isImporting ? 'pi pi-spin pi-spinner' : ''"
        (click)="import()"
        snAssistantAction="import"
        actionHint="Connects the chosen number to the workspace. Calls to it start reaching the agent it gets assigned to."

        [disabled]="!selectedPhoneNumber || !selectedAccountId || isImporting"
        [loading]="isImporting">
      </p-button>
    </div>
  </ng-template>
</p-drawer>
